<template>
    <nav class="navbar navbar-expand-lg navbar-dark" id="navModified">
        <div class="container-fluid">
            <a class="navbar-brand" href="/">
                <img src="@/assets/images/logo_principal.png" alt="Logo El Terreno Gym"
                    width="80" height="80" class="img-fluid" style="padding-right: 7px;" />
                <b class="texto-Nombre">El Terreno Gym</b>
            </a>

            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown"
                aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarNavDropdown">
                <ul class="navbar-nav ms-auto">
                    <!-- <li class="nav-item">
                        <RouterLink class="nav-link active" :to="`${route.path}#informacion`">Información</RouterLink>

                    </li> -->
                    <li class="nav-item active dropdown">
                        <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            Carreras pasadas
                        </a>
                        <ul class="dropdown-menu">
                            <li>
                                <RouterLink to="/carrera-2023" class="dropdown-item">Carrera de Obstaculos - 2023</RouterLink>
                            </li>
                            <li>
                                <hr class="dropdown-divider" />
                            </li>
                            <li>
                                <RouterLink to="/entrenamiento-2024" class="dropdown-item">Entrenamiento #1 - 2024</RouterLink>
                            </li>
                            <li>
                                <hr class="dropdown-divider" />
                            </li>
                            <li>
                                <RouterLink to="/carrera-2024" class="dropdown-item">Carrera de Obstaculos Junio - 2024</RouterLink>
                            </li>
                            <li>
                                <hr class="dropdown-divider" />
                            </li>
                            <li>
                                <RouterLink to="/carrera-2025" class="dropdown-item">Carrera Obstaculos Junio - 2025</RouterLink>
                            </li>
                            <li>
                                <hr class="dropdown-divider" />
                            </li>
                            <li>
                                <RouterLink to="/carrera-octubre-2025" class="dropdown-item">Carrera Atlética Octubre - 2025</RouterLink>
                            </li>
                            <li>
                                <hr class="dropdown-divider" />
                            </li>
                            <li>
                                <RouterLink to="/carrera-bioparque-2026" class="dropdown-item">Carrera Bioparque Estrella Marzo - 2026</RouterLink>
                            </li>
                            <li>
                                <hr class="dropdown-divider" />
                            </li>
                            <li>
                                <RouterLink to="/carrera-canicross-2026" class="dropdown-item">Carrera Canicross Mayo - 2026</RouterLink>
                            </li>
                            <li>
                                <hr class="dropdown-divider" />
                            </li>
                            <li>
                                <RouterLink to="/carrera-obstaculos-julio-2026" class="dropdown-item">Carrera de Obstaculos Julio - 2026</RouterLink>
                            </li>
                        </ul>
                    </li>

                    <li class="nav-item active dropdown">
                        <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            Proximas Carreras
                        </a>
                        <ul class="dropdown-menu">
                            <li>
                                <RouterLink to="/" class="dropdown-item">Reto Entre Cascadas 2026</RouterLink>
                            </li>
                        </ul>
                    </li>

                    <li class="nav-item">
                        <RouterLink class="nav-link active" :to="`${route.path}#contacto`">Contacto</RouterLink>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script setup>
import { useRoute } from 'vue-router'
const route = useRoute()
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Staatliches&family=Roboto:wght@400;700&display=swap');

/* Contenedor Principal con efecto Glassmorphism */
#navModified {
    position: sticky;
    top: 0;
    z-index: 9999;

    background: rgba(27, 30, 32, 0.95);
    backdrop-filter: blur(10px);
    padding: 10px 20px;
    border-bottom: 2px solid #2e7d32;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.3);
    transition: all 0.3s ease;
}

/* Tipografía del Nombre / Logo */
.texto-Nombre {
    font-family: 'Staatliches', cursive;
    color: white;
    font-size: 1.2rem;
    letter-spacing: 2px;
    text-transform: uppercase;
    vertical-align: middle;
}

/* Estilo de los Enlaces (Nav-Links) */
#navModified .nav-link {
    font-family: 'Staatliches', cursive;
    color: rgba(255, 255, 255, 0.8) !important;
    font-size: 1.1rem;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    padding: 10px 20px !important;
    transition: all 0.3s ease;
    position: relative;
}

/* Efecto Hover con línea inferior */
#navModified .nav-link:hover {
    color: #2e7d32 !important;
}

#navModified .nav-link::after {
    content: '';
    position: absolute;
    width: 0;
    height: 2px;
    bottom: 5px;
    left: 50%;
    background-color: #2e7d32;
    transition: all 0.3s ease;
    transform: translateX(-50%);
}

#navModified .nav-link:hover::after {
    width: 70%;
}

/* Estilo del Dropdown (Carreras Pasadas) */
.dropdown-menu {
    background-color: #1B1E20;
    border: 1px solid #2e7d32;
    border-radius: 12px;
    box-shadow: 0 10px 20px rgba(0,0,0,0.5);
    margin-top: 10px;
    padding: 10px;
}

.dropdown-item {
    font-family: 'Roboto', sans-serif;
    color: white !important;
    font-size: 0.9rem;
    padding: 8px 15px;
    border-radius: 8px;
    transition: background 0.2s;
}

.dropdown-item:hover {
    background-color: #2e7d32 !important;
    color: white !important;
}

.dropdown-divider {
    border-top: 1px solid rgba(46, 125, 50, 0.3);
}

/* Botón Toggler para Mobile */
.navbar-toggler {
    border-color: #2e7d32;
    padding: 8px;
}

.navbar-toggler:focus {
    box-shadow: 0 0 0 0.25rem rgba(46, 125, 50, 0.25);
}

/* Ajustes de imagen */
.navbar-brand img {
    transition: transform 0.3s ease;
}

.navbar-brand:hover img {
    transform: scale(1.1) rotate(5deg);
}

@media (max-width: 991px) {
    .navbar-collapse {
        background: #1B1E20;
        padding: 20px;
        border-radius: 15px;
        margin-top: 15px;
        border: 1px solid rgba(46, 125, 50, 0.2);
    }
}
/*@font-face {
    font-family: 'Dangrek';
    src: url('@/assets/fonts/Dangrek-Regular.ttf') format('truetype');
    font-weight: normal;
}

@font-face {
    font-family: 'FjallaOne';
    src: url('@/assets/fonts/FjallaOne-Regular.ttf') format('truetype');
    font-weight: normal;
}

#navModified {
    background: #1B1E20;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
}

#navModified .nav-link {
    font-family: 'FjallaOne';
    font-weight: bold;
    color: white;
    font-size: 18px;
}

.texto-Nombre {
    font-family: 'FjallaOne';
    font-weight: bold;
    color: white;
    font-size: 1.1rem;
}*/

</style>
    <!-- Banner de inicio -->
    <!-- <div class="bannerHome">
        <div class="row align-items-center gx-4">
            <div class="col-lg-6 col-md-12">
                <h4 class="date">Mar 1, 2026</h4>
                <h1 class="title">XHIDENXHI Trail – 7Km</h1>
            </div>

            <div class="col-lg-6 col-md-12 text-center mt-4 mt-lg-0">
                <img src="@/assets/images/LogoBio.png" alt="Logo Banner" class="imgHome img-fluid" />
            </div>
        </div>
    </div> -->
